var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{attrs:{"id":"home"}},[_c('MainMenu'),_c('MainBanner')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }